import { ColumnDef } from "@tanstack/react-table";
import { MentorshipFeedback } from "@/lib/api/mentorships.ts";
import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header.tsx";
import { cn, formatDate } from "@/lib/utils.ts";
import { Badge } from "@/components/ui/badge.tsx";
import { MoreDetails } from "@/components/conversation-details/feedback/ratings/more-details.tsx";

const getSurveyType = (type: string) => {
  switch (type) {
    case "POST_CALL_FEEDBACK_FORM":
      return { label: "Post Call", bgColor: "bg-blue-500" };
    case "FEEDBACK_FORM":
      return { label: "Feedback", bgColor: "bg-green-500" };
    case "QUICK_CHECK_IN_FORM":
      return { label: "Quick Check In", bgColor: "bg-yellow-500" };
    case "BIWEEKLY_FEEDBACK_FORM":
      return { label: "Biweekly", bgColor: "bg-purple-500" };
    case "DAY_28_FEEDBACK_FORM":
      return { label: "Day 28", bgColor: "bg-red-500" };
    case "DAY_3_FEEDBACK_FORM":
      return { label: "Day 3", bgColor: "bg-orange-500" };
    case "DAY_7_FEEDBACK_FORM":
      return { label: "Day 7", bgColor: "bg-pink-500" };
    case "WELLNESS_SURVEY":
      return { label: "Wellness Survey", bgColor: "bg-blue-500" };
    case "SATISFACTION_SURVEY":
      return { label: "Satisfaction Survey", bgColor: "bg-green-500" };
    case "BASELINE_SURVEY":
      return { label: "Baseline Survey", bgColor: "bg-purple-500" };
    case "IRB_RESEARCH_SURVEY":
      return { label: "IRB Research Survey", bgColor: "bg-red-500" };
    case "SUICIDAL_IDEATION_SURVEY":
      return { label: "Suicidal Ideation Survey", bgColor: "bg-red-500" };
    default:
      return { label: "-", bgColor: "bg-gray-500" };
  }
};

export const columns: ColumnDef<MentorshipFeedback["ratingList"][number]>[] = [
  {
    accessorKey: "created_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Date" />
    ),
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => {
      return (
        <div className="flex items-center justify-center">
          {row.original.created_at
            ? formatDate(row.original.created_at) || "-"
            : "-"}
        </div>
      );
    },
  },
  {
    accessorKey: "rating",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Rating" />
    ),
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => {
      return (
        <div className="flex items-center justify-center">
          {row.original.rating || "-"}
        </div>
      );
    },
  },
  {
    accessorKey: "type",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Type" />
    ),
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => {
      const { bgColor, label } = getSurveyType(row.original.type!);
      return (
        <div className="flex items-center justify-center">
          <Badge
            className={cn(
              "rounded-sm bg-red-300 text-center hover:bg-red-300",
              bgColor,
            )}
          >
            {label}
          </Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "responses",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Response" />
    ),
    enableSorting: false,
    enableHiding: false,
    cell: ({ row }) => {
      return (
        <div className="flex items-center justify-center">
          <MoreDetails data={row.original} />
        </div>
      );
    },
  },
];
